import React, { Fragment } from 'react'
import EditCustomerView from '../../../components/front_office/edit_customer/EditCustomerView'

const EditCustomerEditUpdateView = () => {
  return (
    <Fragment>
        <EditCustomerView />
    </Fragment>
  )
}

export default EditCustomerEditUpdateView